module.exports = __webpack_public_path__ + "img/rain.d8fdecc0.svg";